import type { TooltipHandle } from '@arco-design/web-react/es/Tooltip';

import type { TooltipProps } from './const';
import { Tooltip as ArcoTooltip } from '@arco-design/web-react';
import { cn } from '@utils';
import { forwardRef } from 'react';

import './index.less';

function Tooltip(props: TooltipProps, ref: React.Ref<TooltipHandle>) {
  const { className, priority, triggerProps, style, children, ...reset } = props;

  return (
    <ArcoTooltip
      {...reset}
      ref={ref}
      triggerProps={{
        showArrow: false,
        mouseEnterDelay: triggerProps?.mouseEnterDelay ?? 300,
        ...triggerProps,
      }}
      style={{ maxWidth: '280px', ...style }}
      className={cn('wg-tooltip', { 'wg-tooltip--high': priority === 'high' }, className)}
    >
      {children}
    </ArcoTooltip>
  );
}

const TooltipComponent = forwardRef<TooltipHandle, TooltipProps>(Tooltip);

TooltipComponent.displayName = 'Tooltip';

export default TooltipComponent;

export type { TooltipHandle, TooltipProps };
